export const CROPPER_CONSTANTS = {
    TITLE: 'Редагувати фото',
    SIZE_LABEL: (width: number, height: number) => `Розмір фото: ${width}x${height}`,
};
